import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'publicDataDeletionStatusPage.title',
    defaultMessage: 'Data Deletion Status',
  },
  confirmed: {
    id: 'publicDataDeletionStatusPage.confirmed',
    defaultMessage: 'Data Deletion Confirmed',
  },
  confirmedDescription: {
    id: 'publicDataDeletionStatusPage.confirmedDescription',
    defaultMessage: 'Your WhatsApp-related data has been successfully deleted in accordance with Meta\'s data deletion request.',
  },
  deletionCompletedOn: {
    id: 'publicDataDeletionStatusPage.deletionCompletedOn',
    defaultMessage: 'Deletion completed on:',
  },
  confirmationCode: {
    id: 'publicDataDeletionStatusPage.confirmationCode',
    defaultMessage: 'Confirmation Code:',
  },
  confirmationCodeDescription: {
    id: 'publicDataDeletionStatusPage.confirmationCodeDescription',
    defaultMessage: 'This confirmation code can be used for verification with Meta\'s Data Deletion API. All personal data obtained through WhatsApp has been permanently removed from our systems.',
  },
  notFound: {
    id: 'publicDataDeletionStatusPage.notFound',
    defaultMessage: 'Confirmation Code Not Found',
  },
  notFoundDescription: {
    id: 'publicDataDeletionStatusPage.notFoundDescription',
    defaultMessage: 'The confirmation code provided could not be found in our system.',
  },
  providedCode: {
    id: 'publicDataDeletionStatusPage.providedCode',
    defaultMessage: 'Provided Code:',
  },
  notFoundDetails: {
    id: 'publicDataDeletionStatusPage.notFoundDetails',
    defaultMessage: 'This may occur if the code is invalid, has expired, or if the deletion was already verified. If you believe this is an error, please contact support.',
  },
  voiceArchive: {
    id: 'publicDataDeletionStatusPage.voiceArchive',
    defaultMessage: 'VoiceArchive',
  },
  privacyPolicy: {
    id: 'publicDataDeletionStatusPage.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
})
